import { type ReactElement } from 'react';
import Select, { ISelectOption } from '@creditflowresearch/uilib/Select';

interface ITabSelectProps<T extends string> {
  tabs: Record<T, { name: string }>,
  activeTab: T,
  onChangeTab: (tab: T) => void,
  dataTest?: string,
  instanceId?: string,
}

const TabSelect = <T extends string>({
  tabs,
  activeTab,
  onChangeTab,
  dataTest = 'tabSelect',
  instanceId,
}: ITabSelectProps<T>): ReactElement => {
  const options: ISelectOption[] = Object.entries<{ name: string }>(tabs)
    .map(([key, { name }]) => ({ label: name, value: key }));

  const value = options.find((option) => option.value === activeTab) || options[0];

  const handleChange = (option: ISelectOption): void => {
    onChangeTab(option.value as T);
  };

  return (
    <Select
      instanceId={ instanceId }
      value={ value }
      options={ options }
      onChange={ handleChange }
      isSlim
      isNarrow
      isSearchable={ false }
      dataTest={ dataTest }
      size="S"
    />
  );
};

export default TabSelect;
